import styled from "styled-components";

export const SelectBox = styled.select`
    padding: 10px;

    font-size: 1.5rem;

    color: ${({theme}) => theme.colors.textLight};
    background-color: ${props => props.theme.colors.backgroundDark};

    border-radius: ${({theme}) => theme.layout.border.radius};
    border-color: ${({theme}) => theme.colors.boxBorderContrast};
    border-width: 2px;
    border-style: solid;
`;